import { TTransport } from '@/types/models';

import { TRACKING_CASES, TRANSPORT_EVENTS_UUIDS } from './constants';

const PICKUP_MAP_CASES = new Set([
  TRACKING_CASES.outForPickup,
  TRACKING_CASES.intervalPickup,
  TRACKING_CASES.pickedUp,
]);

type MapCoordinates = {
  latitude: string | number | null;
  longitude: string | number | null;
};

const readCoordinates = (
  transport: TTransport,
  role: 'sender' | 'recipient'
): MapCoordinates => {
  if (role === 'sender') {
    return {
      latitude: transport.sender_latitude ?? null,
      longitude: transport.sender_longitude ?? null,
    };
  }

  return {
    latitude: transport.recipient_latitude ?? null,
    longitude: transport.recipient_longitude ?? null,
  };
};

const getMapDestinationCoordinates = (
  selectedCase: string | null,
  transport: TTransport | null
): MapCoordinates => {
  if (!transport || !selectedCase) {
    return { latitude: null, longitude: null };
  }

  if (selectedCase === TRACKING_CASES.postponed) {
    const isPickupPostponed = transport.events.some(
      (event) => event.event.uuid === TRANSPORT_EVENTS_UUIDS.pickupPostponed
    );

    return readCoordinates(
      transport,
      isPickupPostponed ? 'sender' : 'recipient'
    );
  }

  if (PICKUP_MAP_CASES.has(selectedCase)) {
    return readCoordinates(transport, 'sender');
  }

  return readCoordinates(transport, 'recipient');
};

export { getMapDestinationCoordinates };
